"use strict";

var version = "pf";

jQuery(document).ready(function ($) {

  $("#form-version").on("click", function () {
    formVersionConfig($(this).find(".active input:radio").val());
  });

  var form = $('#vw-caminhoes-form');
  var cepField = form.find('.cep');
  var cpf = form.find('input.cpf');
  var cnpj = form.find('input.cnpj');
  var phoneField = form.find('.phone');
  var cityField = form.find('.city');

  formValidateConfig(form);
  maskCep(cepField);
  maskPhone(phoneField);
  maskCnpj(cnpj);
  maskCpf(cpf);

  validatorCep();
  validatorEmail();
  validatorCnpj();
  validatorPhone();
  validatorCpf();

  loadCityByCep(cepField, cityField);
  loadDealershipByCity(cityField);

  document.getElementById("vw-caminhoes-form").addEventListener('submit', submitVwForm);
});

function formVersionConfig(option) {
  var form = $("#vw-caminhoes-form");
  if (option != version) {
    version = option;
    if (option == "pf") {
      form.find("div.razaosocial").slideUp();
      form.find("div.cnpj").slideUp();
    } else if (option == "pj") {
      form.find("div.razaosocial").slideDown();
      form.find("div.cnpj").slideDown();
    }
  }
}

function submitVwForm(e) {
  e.preventDefault();

  var form = $(this),
      name = form.find('.name').val(),
      cpf = form.find('.cpf').val(),
      email = form.find('.email').val(),
      phone = form.find('.phone').val(),
      cep = form.find('.cep').val(),
      dealership = form.find('.dealerships input:checked').val(),
      oferta = form.attr('offer'),
      button = form.find('button[type="submit"]'),
      valid = true,
      lgpd = [],
      cnpj = '',
      razaoSocial = '';

  if (version == 'pj') {
    cnpj = form.find('input.cnpj').val();
    razaoSocial = form.find('input.razaosocial').val();

    if (cnpj == '' || razaoSocial == '') {
      populateAndShowFormError(form, ["CNPJ e Razão social obrigatória em caso de Pessoa Jurídica"]);
      valid = false;
    }
  }

  form.find(".jc-opt-in").each(function () {
    if ($(this).prop('checked')) {
      lgpd.push([$(this).attr('name'), $(this).parents(".form-group").text().trim(), $(this).parents(".form-group").find('a') ? $(this).parents(".form-group").find('a').map(function () {
        return $(this).attr('href');
      }).get() : null]);
    }
  });

  if (form.valid() && valid) {
    var buttonLabel = button.text();
    button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

    grecaptcha.ready(function () {
      grecaptcha.execute(ajax.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

        $.ajax({
          url: ajax.url,
          type: 'POST',
          data: {
            action: 'jc_ajax_save_lead_vw_caminhoes',
            context: 'lead',
            oferta: oferta,
            name: name,
            cpf: cpf,
            cnpj: cnpj,
            email: email,
            phone: phone,
            cep: cep,
            dealership: dealership,
            razaoSocial: razaoSocial,
            lgpd: encodeURIComponent(JSON.stringify(lgpd)),
            token: grecaptchaToken
          },
          success: function success(response) {
            if (response && response.success) {
              var leadID = response.data.leadID;
              send_offer_lead_success_events(oferta, leadID, 'Oferta').then(function () {
                window.location.href += (window.location.href.indexOf("?") > -1 ? '&' : '?') + 'pagina=obrigado&id=' + leadID;
              });
            } else {
              populateAndShowFormError(form, response.data);
              button.prop('disabled', false).html(buttonLabel);
            }
          },
          error: function error(data) {
            showFormError(form);
            button.prop('disabled', false).html(buttonLabel);
          }
        });
      });
    });
  }
}